import { useCursorHandlers } from '../../../contexts/CursorContext/Cursor';
import { useTheme } from '@mui/material/styles';

export const useEditorHandlers = (name: string) => {
  const theme = useTheme();

  return useCursorHandlers({
    name,
    styles: [
      {
        name: 'theme_component_game_description_background_color',
        label: 'Description Section Background Color',
        type: 'color',
        default: theme.palette.secondary.dark,
        helperText: 'Description area background Color',
      },
      {
        name: 'theme_component_game_description_font_color',
        label: 'Description Section Font Color',
        type: 'color',
        default: theme.palette.secondary.light,
        helperText: 'Description area background Color',
      },
    ],
    configuration: [
      {
        name: 'component_game_player_header_style',
        label: 'Header layout style',
        type: 'select',
        default: 'full',
        options: ['hidden', 'minimal', 'full'],
      },
      {
        name: 'component_walk_through_publisher_id',
        label: 'Tubia publisher identifier',
        type: 'text',
        helperText: 'The publisher identifier can be requested through your account manager.',
      },
      {
        name: 'component_share_enable_web_api',
        label: 'Enable share button',
        type: 'checkbox',
        default: false,
        helperText: 'Will open the client device its default sharing options (only on mobile devices).',
      },
      {
        name: 'component_share_enable_embed_clipboard',
        label: 'Enable embed button',
        type: 'checkbox',
        default: false,
        helperText: 'Will add the game URL to the client its clipboard.',
      },
      {
        name: 'component_game_mobile_play_button_background_color',
        label: 'Mobile Play Button Background Color',
        type: 'text',
        helperText: 'On Mobile Game Page is changing for navigator devices',
      },
      {
        name: 'component_game_mobile_play_button_color',
        label: 'Mobile Play Button Font Color',
        type: 'text',
        helperText: 'On Mobile Game Page is changing for navigator devices',
      },
    ],
  });
};
